
import BaseActionButton from '@/components/common/BaseActionButton.vue'

export default {
  name: 'ConfirmDialog',
  components: { BaseActionButton },
  props: {
    title: { type: String, required: true },
    // 问句正文（"确认取消此订单？"）
    message: { type: String, default: '' },
    // 后果文案（"取消后不可恢复"）：C 类必填，由门面在调用期强制
    consequence: { type: String, default: '' },
    okLabel: { type: String, default: '确定' },
    cancelLabel: { type: String, default: '取消' },
    // primary=流程推进蓝 / attention=不可逆但不破坏（仓内语义，如改为自提）/ danger=危险（低饱和红）
    semantic: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'attention', 'danger'].includes(v)
    },
    // 常驻：点遮罩/Esc 不关。由门面按 B/C 分类决定（C 恒 true）
    persistent: { type: Boolean, default: false },
    /**
     * 可选：把这一次请求放进弹窗执行。
     * 传入后——确认键 loading + disabled（连点只发一次）；抛错则**保留弹窗**并显示原因；
     * 成功才 emit('ok') 关窗。不传则纯二值决定（点确认立即关窗）。
     */
    action: { type: Function, default: null }
  },
  data () {
    return { loading: false, error: '' }
  },
  methods: {
    // ↓↓ Quasar 自定义弹窗三件套：插件只认这三个入口
    show () { this.$refs.dlg.show() },
    hide () { this.$refs.dlg.hide() },
    onDialogHide () { this.$emit('hide') },

    onCancel () {
      if (this.loading) return // 请求进行中不给关（否则请求结果无处安放）
      this.hide()
    },

    async onOk () {
      if (this.loading) return // 重复点击保护（按钮 disabled 之外再兜一层）
      if (!this.action) {
        this.$emit('ok')
        this.hide()
        return
      }
      this.loading = true
      this.error = ''
      try {
        await this.action()
        this.$emit('ok')
        this.hide()
      } catch (e) {
        this.error = this.errorText(e)
      } finally {
        this.loading = false
      }
    },

    errorText (e) {
      if (!e) return '操作失败，请重试'
      // 后端业务失败：拿服务端 message（与仓内各页 catch 分支同口径）
      const server = e.response && e.response.data && e.response.data.message
      return server || e.message || '操作失败，请重试'
    }
  }
}
